import { useCallback } from "react";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useDefaultScannerBehavior } from "../../hooks/useDefaultScannerBehavior";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { handleScanResult } from "../../helpers/handleScanResultUtils";
import { mapBarcodeFormatToSymbologyType } from "./cameraScannerPageUtils";
import { CameraScannerComponent } from "./CameraScannerComponent";
import { ScanResult } from "../../hooks/useDetectBarcode";

function CameraScannerPage() {
  const { navigateToSearch, taskType } = useDefaultScannerBehavior();
  const navigate = useFixaNavigate();

  const onDetected = useCallback(
    (scanResult: ScanResult) => {
      trackerHelper.trackNewCameraScannerUsed();
      handleScanResult(
        {
          scannedBarcode: scanResult.barcode,
          symbologyFormat: mapBarcodeFormatToSymbologyType(scanResult.format),
        },
        taskType,
        navigate
      );
    },
    [taskType, navigate]
  );

  return (
    <CameraScannerComponent
      onDetected={onDetected}
      presentationProps={{
        taskType,
        pushSearch: navigateToSearch,
      }}
    />
  );
}

export default CameraScannerPage;
